import React from 'react';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import InfoIcon from 'Components/Icons/LinkRedirection';

const Container = styled.div`
  display: flex;
  gap: 16px;
`;

const Message = styled.div``;

const Divider = styled.div`
  border-right: solid 1px var(--k-ds-color-border);
`;

const Button = styled.button`
  all: unset;
  color: var(--k-ds-color-interactive-primary);
  &:hover {
    color: var(--k-ds-color-interactive-secondary);
  }
`;

const RedirectToast = ({
  message = '',
  duration = Infinity,
  onClose = () => {},
}) => (
  toast(t => (
    <Container>
      <Message
        className="k-ds-body-01 k-ds-text-color-secondary "
      >
        { message }
      </Message>
      <Divider />
      <Button
        className="k-ds-body-01 "
        type="button"
        onClick={(e) => {
          toast.dismiss(t.id);
          onClose(e, t.id);
        }}
      >
        Cerrar
      </Button>
    </Container>
  ),
  {
    duration,
    icon: <InfoIcon width={50} height={50} />,
    position: 'top-center',
  })
);

export default RedirectToast;
